const actions = {
  setReportCard({ commit, dispatch }, payload) {
    commit("setReport", payload);
  },
  setReportCards({ commit, dispatch }, payload) {
    commit("setReports", payload);
  },
  setDateOfReport({ commit, dispatch }, payload) {
    commit("setDateOfReport", payload);
  },
  setReportCardOldState({ commit, dispatch }, payload) {
    commit("setReportCardOldState", payload);
  }
};

export default actions;
